import React from 'react';

import { convertToRoman } from 'helpers/convertToRoman';
import { Container } from './Description.styles';

export interface DescriptionProps {
	position: number;
	title: string;
	description: string;
}

export const Description = ({
	position,
	title,
	description,
}: DescriptionProps) => {
	const callText = `Guía de referencia ${convertToRoman(position + 1)}`;

	return (
		<Container>
			<h2>{callText}</h2>
			<h3>{title}</h3>
			<p>{description}</p>
		</Container>
	);
};
